import Editable from "../../Editable";
import InfoField from "../../InfoField";
import { useQuery } from "@apollo/client";
import ORGANIZATION from "../../../api/queries/organization";
import ORGANIZATION_TYPES from "../../../api/queries/organizationTypes";
import UPDATE_ORGANIZATION from "../../../api/mutations/updateOrganization";
// import SPORTS from "../../../api/queries/sports";
import moment from "moment";
import Form from "../../Form";
import { FaTimes } from "react-icons/fa";

import Loading from "../../Loading";
import { Fragment } from "react";

function OrganizationClassification({ id }) {
  const { loading, error, data } = useQuery(ORGANIZATION, {
    variables: { id },
  });

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    // return <div>Loading</div>;
  }

  const organization = data?.organization;

  return (
    <div className="card">
      <div className="card-title">Classifications</div>
      {loading || !data ? (
        <div className="loading-wrapper">
          <Loading />
        </div>
      ) : (
        <Fragment>
          <div className="card-body">
            {organization.types.map((t) => (
              <Editable
                form={(setEditing) => (
                  <Form
                    className={"editable-field-form"}
                    initialState={{ id: "" }}
                    fields={[
                      {
                        label: `Are your sure? Type ${t.id} to confirm`,
                        type: "text",
                        key: "id",
                      },
                    ]}
                    mutation={UPDATE_ORGANIZATION}
                    update={(cache, { data: { updateOrganization } }) => {
                      const q = cache.readQuery({
                        query: ORGANIZATION,
                        variables: { id },
                      });
                      cache.writeQuery({
                        query: ORGANIZATION,
                        variables: { id },
                        data: {
                          organization: {
                            ...q.organization,
                            types: updateOrganization.types,
                          },
                        },
                      });

                      setEditing(false);
                    }}
                    vars={(s) => ({
                      where: { id },
                      data: {
                        types: {
                          disconnect: { id: s.id },
                        },
                      },
                    })}
                    options={[
                      <div
                        className="option cancel"
                        onClick={() => {
                          setEditing(false);
                        }}
                      >
                        <FaTimes />
                      </div>,
                    ]}
                  />
                )}
                content={(setEditing) => (
                  <InfoField
                    setEditing={setEditing}
                    disableEditing={true}
                    label={"Type"}
                    value={t.name}
                    required={false}
                  />
                )}
              />
            ))}
          </div>

          <div className="card-footer">
            <Editable
              form={(setEditing) => (
                <Form
                  className={"editable-field-form"}
                  initialState={{
                    type: "",
                  }}
                  fields={[
                    {
                      label: "Type",
                      type: "select",
                      key: "type",
                      query: ORGANIZATION_TYPES,
                      items: (d) => d.organizationTypes,
                      optionLabel: (i) => i.name,
                    },
                  ]}
                  mutation={UPDATE_ORGANIZATION}
                  update={(cache, { data: { updateOrganization } }) => {
                    const q = cache.readQuery({
                      query: ORGANIZATION,
                      variables: { id },
                    });
                    cache.writeQuery({
                      query: ORGANIZATION,
                      variables: { id },
                      data: {
                        organization: {
                          ...q.organization,
                          types: updateOrganization.types,
                        },
                      },
                    });

                    setEditing(false);
                  }}
                  vars={(s) => {
                    return {
                      where: { id },
                      data: {
                        types: {
                          connect: {
                            id: s.type,
                          },
                        },
                      },
                    };
                  }}
                  options={[
                    <div
                      className="option cancel"
                      onClick={() => {
                        setEditing(false);
                      }}
                    >
                      <FaTimes />
                    </div>,
                  ]}
                />
              )}
              content={(setEditing) => (
                <div
                  className={"App-btn success hover-pointer "}
                  onClick={() => {
                    setEditing(true);
                  }}
                >
                  Add Organization Type
                </div>
              )}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default OrganizationClassification;
